export const BASE_PATH_ANALYTICS = {
  PORTAL_OOBE: '/PortalOobe/',
  HW_STATUS_CHECK: '/HardwareStatusCheck/',
} as const

export const SIMPLE_UI_EVENT = {
  VERSION: '1.4.0',
  ENVELOPE_VERSION: '1.4.0',
  EVENT_DETAIL_TYPE:
    'com.hp.cdm.domain.telemetry.type.eventDetail.category.simpleUi.version.1',
  EVENT_CATEGORY: 'simpleUi',
}

export const DEVICE_SETUP_CHECK_EVENT = {
  VERSION: '1.0.0',
  ENVELOPE_VERSION: '1.4.0',
  EVENT_DETAIL_TYPE:
    'com.hp.cdm.domain.telemetry.type.eventDetail.category.deviceSetupCheck.version.1',
  EVENT_CATEGORY: 'deviceSetupCheck',
}

export const ACTIVITY_ANALYTICS = {
  PAIRING: 'PairingCode-v01',
  CONFIGURE: 'ConfigureAndTest-v01',
  ASSIGN: 'AssignOwnership-v01',
  ALL: 'All-v01',
  INSTALL_DRIVER: 'InstallDriversAndTestPage-v01',
  HP_SMART_ADMIN: 'HpSmartAdminHandOff-v01',
  INSTANT_INK: 'InstantInk-v01',
  INSTALL_PRINT_SOFTWARE: 'InstallPrintSoftware-v01',
  FIRMWARE_UPDATE: 'FirmwareUpdate-v01',
  ACCOUNT_VALUE_PROP: 'AcctValueProp-v01',
  WELCOME_PAGE: 'WelcomePage-v01',
  HARDWARE_SETUP: 'HardwareSetup-v01',
} as const

export const SCREEN_ANALYTICS = {
  ACCOUNT_VALUE_PROP: 'AccountValueProp',
  ACCOUNT_VALUE_PROP_SPLASH: 'AccountValuePropSplash',
  ACK_HP_PLUS: 'AckHpPlus',
  ACTIVATE: 'Activate',
  COMPANY_NAME: 'CompanyName',
  CLOUD_VALUE_PROP: 'CloudValueProp',
  CONNECT: 'Connect',
  FIRMWARE_UPDATE_CHOICE: 'FirmwareUpdateChoice',
  FIRMWARE_UPDATE_NOTICE: 'Iris',
  GO: 'Go',
  HARDWARE_STATUS_CHECK: 'HardwareStatusCheck',
  NAME_AND_LOCATION: 'PrinterName',
  WELCOME_PAGE: 'WelcomePage',
  WELCOME_PAGE_SPINNER: 'WelcomePageSpinner',
  PAIRING_CODE: 'EnterPairingCode',
  PAIRING_CODE_SUCCESS: 'PairingCodeSuccess',
  PARTNER_LINK: 'Pn',
  PORTAL_HANDOFF: 'SmartAdminValueProp',
  PRINTER_ACTIVATION: 'PrinterActivationProgress',
  PRINTER_ACTIVATION_SUCCESS: 'PrinterActivationSuccess',
  PRINTER_NOT_SUPPORTED: 'PrinterUnsupported',
  START_SCAN: 'StartScan',
  UNRECOVERABLE_ERROR: 'UnrecoverableError',
  HP_PLUS_SAFETY_NET: 'HpPlusSafetyNet',
  HP_PLUS_CALL_SUPPORT: 'HpPlusCallSupport',
  HP_ALL_IN_NO_ACCOUNT: 'HpAllInNoAccount',
  HP_ALL_IN_WRONG_ACCOUNT: 'HpAllInWrongAccount',
} as const

export const MODAL_SCREEN_ANALYTICS = {
  DOMAIN_ERROR: 'DomainErrorModal',
  CANNOT_FIND_PAIRING_CODE: 'CantFindPairCodeModal',
  COUNTRY_SUPPORTED_LIST: 'CountrySupportedList',
  CODE_LIMIT: 'CodeLimitError',
  DECLINE_ONBOARDING: 'DeclineOnboarding',
  EXPIRED_CODE: 'ExpiredCodeError',
  FEATURE_MODAL: 'FeatureModal',
  GENERIC_ACTIVATION_ERROR: 'GenericActivationError',
  PAIRING_CODE_DOWN_ERROR: 'PairingCodeDownError',
  PAIRING_TOKEN_ERROR: 'PairingTokenActivationError',
  RECONSIDER_MODAL: 'ReconsiderModal',
  RETRY_GENERIC_ACTIVATION_ERROR: 'RetryGenericActivationError',
  SHORTCUT_CREATION_ERROR: 'ScanToEmailCreationError',
  WRONG_PRINTER_ERROR: 'WrongPrinterError',
  PRINTER_SETUP_COMPLETE: 'PrinterSetupCompleteModal',
  COMPLETE_SETUP_SOMEONE_ELSE: 'CompleteSetupSomeoneElseModal',
} as const

export const BUTTONS_ANALYTICS = {
  CONTINUE: 'ContinueButton',
  SIGN_IN: 'SignInButton',
  CREATE_ACCOUNT: 'CreateAccountButton',
  EXIT_SETUP: 'ExitSetupButton',
  TRY_AGAIN: 'TryAgainButton',
  SUPPORT: 'HpSupportButton',
  CONFIRM: 'ConfirmButton',
  CREATE_ACC_SIGN_IN: 'CreateAccSignInButton',
  PRINTER_NAME: 'PrinterNameText',
  PRINTER_LOC: 'PrinterLocText',
  SKIP: 'SkipButton',
  GO_TO_SMART_ADMIN: 'GoToSmartAdminButton',
  SETUP_PRINT: 'SetUpPrintButton',
  SETUP_SCAN: 'SetUpScanDestinationsButton',
  SETUP_FAX: 'SetUpFaxButton',
  INVITE_USERS_ADMINS: 'InviteUsersAdminsButton',
  SETUP_SCAN_CLOSE: 'SetUpScanDestinationsCloseButton',
  INVITE_USERS_ADMINS_CLOSE: 'InviteUsersAdminsCloseButton',
  INSTALL_HP_SMART: 'InstallHpSmartButton',
  PRINT_TEST_PAGE: 'PrintTestPageButton',
  ENABLE_PRINT_ANYWHERE: 'PrintAnywhereToggle',
  REQUIRE_PRIVATE_PICKUP: 'RequirePrivatePickupToggle',
  SETUP_PRINT_SEND_TEST_PAGE_DONE: 'SetUpPrintSendTestPageDoneButton',
  ORG_NAME: 'OrgNameText',
  ORG_DESC: 'OrgDescText',
  RADIO: 'RadioButton',
  SELECT_COUNTRY: 'SelectCountryDropDown',
  OK: 'OkButton',
  INSTALL_DRIVER: 'InstallDriverButton',
  CLOSE: 'CloseButton',
  BACK: 'BackButton',
  CONTINUE_SETUP: 'ContinueSetupButton',
  CANCEL_SETUP: 'CancelSetupButton',
  CANCEL_SETUP_MANUAL: 'CancelSetupManualButton',
  CONFIRM_CONTINUE: 'ConfirmContinueButton',
  COPY_TEMPLATE: 'CopyTemplateButton',
  APPLY: 'ApplyButton',
  HP_SMART_ADMIN: 'HpSmartAdminButton',
  COMPANY_SELECT_BUTTON: 'CompanySelectButton',
  PERSONAL_SELECT_BUTTON: 'PersonalSelectButton',
  HP_SMART_INSTALL_BUTTON: 'HpSmartInstallButton',
  GET_CODE_THROUGH_NETWORK_BUTTON: 'GetCodeThroughNetworkButton',
  GET_CODE_THROUGH_EWS_BUTTON: 'GetCodeThroughEwsButton',
  DECLINE_HP_PLUS_BUTTON: 'DeclineButton',
  BACK_TO_OFFER_BUTTON: 'BackToOfferButton',
  GO_TO_DASHBOARD: 'GoToDashboardButton',
  LEARN_MORE: 'LearnMoreButton',
  LEARN_MORE_HP_PLUS_OVERVIEW: 'HpPlusOverviewButton',
  LEARN_MORE_HP_PLUS_REQUIREMENTS: 'HpPlusRequirementsButton',
  LEARN_MORE_INSTANT_INK: 'InstantInkButton',
  LEARN_MORE_FOREST_FIRST: 'ForestFirstPrintingButton',
  LEARN_MORE_HP_SMART_ADVANCE: 'HpSmartAdvanceButton',
  LEARN_MORE_HP_SMART_PRO: 'HpSmartProButton',
  LEARN_MORE_SMART_SECURITY: 'SmartSecurityButton',
  VISIT_WEBSITE: 'VisitWebsiteButton',
  GET_NEW_PAIRING_CODE: 'GetNewPairingCodeButton',
  BACK_TO_ACCOUNT: 'BackToAccountButton',
  CANNOT_CREATE: 'CannotCreateAccountButton',
  DOMAIN_ERROR_INLINE: 'DomainErrorInline',
} as const

export const LINKS_ANALYTICS = {
  HP_SMART_TOU: 'HpSmartTouLink',
  END_USER_AGREEMENT_LINK: 'EndUserAgreementLink',
  HP_SUPPORT: 'HpSupportLink',
  LEARN_ABOUT_HP_SMART: 'LearnAbtHpSmartLink',
  SUPPORTED_COUNTRIES: 'SupportedCountriesLink',
  LEARN_MORE: 'LearnMoreLink',
  INSTANT_INK_ONE: 'InstantInkOneLink',
  INSTALL_HP_SMART: 'InstallHpSmartLink',
  DRIVER_CONFIRM: 'DriverConfirmLink',
  DOWNLOAD_HP_EASY_START: 'DownloadHpEasyStartLink',
  HP_DRIVER_LINK: 'HpDriverLink',
  HP_EASY_START_DOWNLOAD: 'HpEasyStartDownloadLink',
  HP_EASY_START_LINK: 'HpEasyStartLink',
  LEARN_HP_SMART: 'LearnHpSmartLink',
  HP_SMART_DRIVER: 'HpSmartDriverLink',
  INSTALL_DRIVER: 'InstallDriverLink',
  CANT_FIND_PAIRING_CODE: 'CantFindPairingCodeLink',
  SETUP_WITHOUT_HP_CLOUD_LINK: 'SetupWithoutHpCloudLink',
  SETUP_FOR_PERSONAL_USE: 'SetupForPersonalUse',
  FEATURE_LINK: 'FeatureLink',
  HP_PLUS_BENEFITS_LINK: 'HpPlusBenefitsLink',
  SIGN_IN: 'SignInLink',
  PROMO_INFO_LINK: 'PromoInfoLink',
  VIEW_INSTRUCTIONS: 'ViewInstructionsLink',
  HP_SMART_ADMIN: 'HpSmartAdminLink',
  COMPLETE_SETUP_SOMEONE_ELSE: 'CompleteSetupForSomeoneElseLink',
  ALL_IN_PLAN_SUPPORT: 'AllInPlanSupportLink',
} as const

export const ACTIONS_ANALYTICS = {
  SCREEN_DISPLAYED: 'ScreenDisplayed',
  CONTROL_BUTTON_CLICKED: 'ControlButtonClicked',
  MODAL_WINDOW_DISPLAYED: 'ModalWindowDisplayed',
  CONTROL_DISPLAYED: 'ControlDisplayed',
  CONTROL_HYPERLINK_CLICKED: 'ControlHyperLinkClicked',
  CONTROL_TOGGLE_ENABLED: 'ControlToggleEnabled',
  CONTROL_TOGGLE_DISABLED: 'ControlToggleDisabled',
  CONTROL_ACCORDIAN_EXPANDED: 'ControlAccordianExpanded',
  CONTROL_ACCORDIAN_COLLAPSED: 'ControlAccordianCollapsed',
} as const

export const MODE_ANALYTICS = {
  IOT: 'IotScreen',
  RTP: 'RtpScreen',
  TOKEN: 'TokenScreen',
  INITIATION: 'InitiationScreen',
  REGISTER_DEVICE: 'RegisterDeviceScreen',
  CREATE_SCAN_TO_EMAIL: 'CreateScanToEmail',
  SET_DEVICE_SHADOW_CONFIG: 'SetDeviceShadowConfig',
  CREATE_SHORTCUTS_SESSION: 'CreateShortcutsSession',
  MULTI_FUNCTION: 'MultiFunction',
  SINGLE_FUNCTION: 'SingleFunction',
  RETAILER_REFURB: 'RetailerRefurb',
  YETI_STANDARD: 'YetiStandard',
  GEN2: 'Gen2',
  GEN1: 'Gen1',
} as const

export type BasePathAnalytics = typeof BASE_PATH_ANALYTICS

export type ActivityAnalytics = typeof ACTIVITY_ANALYTICS

export type ScreenAnalytics = typeof SCREEN_ANALYTICS

export type ModalScreenAnalytics = typeof MODAL_SCREEN_ANALYTICS

export type ButtonsAnalytics = typeof BUTTONS_ANALYTICS

export type LinksAnalytics = typeof LINKS_ANALYTICS

export type ActionsAnalytics = typeof ACTIONS_ANALYTICS

export type ModeAnalytics = typeof MODE_ANALYTICS
